export const ROLE_LABELS = {
  super_admin: "Super Admin",
  hr: "HR",
  quality: "Quality",
  management: "Management",
  employee: "Employee",
};

export const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function statusBadge(status) {
  switch (status) {
    case "competent":
    case "pass":
    case "conducted":
    case "addressed":
      return { label: status, cls: "bg-green-100 text-green-800 border-green-200" };
    case "gap":
    case "fail":
    case "overdue":
      return { label: status, cls: "bg-red-100 text-red-800 border-red-200" };
    case "not_assessed":
    case "pending":
    case "open":
      return { label: status.replace("_", " "), cls: "bg-amber-50 text-amber-800 border-amber-200" };
    case "scheduled":
    case "revised":
      return { label: status, cls: "bg-blue-50 text-blue-800 border-blue-200" };
    case "planned":
      return { label: status, cls: "bg-neutral-100 text-neutral-700 border-neutral-200" };
    case "cancelled":
      return { label: status, cls: "bg-neutral-200 text-neutral-500 border-neutral-300 line-through" };
    default:
      return { label: status || "—", cls: "bg-neutral-100 text-neutral-700 border-neutral-200" };
  }
}
